exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".emoji-mart-vue-icon[data-v-b523fe4e]{vertical-align:middle;box-sizing:content-box}\n", ""]);

